/**
 * Modelo de classe para representar o reset de uma senha.
 */
export class ResetSenha {
  senhaAtual: string;
  novaSenha: string;
}
